import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row mt-5 pt-5" }
const _hoisted_3 = { class: "col-12" }
const _hoisted_4 = { class: "d-flex justify-content-between align-items-center mb-4" }
const _hoisted_5 = { "aria-label": "breadcrumb" }
const _hoisted_6 = { class: "breadcrumb mb-0" }
const _hoisted_7 = { class: "breadcrumb-item" }
const _hoisted_8 = { class: "breadcrumb-item" }
const _hoisted_9 = { class: "d-flex gap-2" }
const _hoisted_10 = ["disabled"]
const _hoisted_11 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-2"
}
const _hoisted_12 = {
  key: 1,
  class: "fas fa-save me-1"
}
const _hoisted_13 = {
  key: 0,
  class: "text-center py-5"
}
const _hoisted_14 = {
  key: 1,
  class: "alert alert-danger"
}
const _hoisted_15 = {
  key: 2,
  class: "card"
}
const _hoisted_16 = { class: "card-body" }

import { ref, onMounted } from "vue";
import { useRouter, useRoute } from "vue-router";
import apiService from "@/services/apiService";
import BlogForm from "@/components/pms/admin/BlogForm.vue";

// Router

export default /*@__PURE__*/_defineComponent({
  __name: 'BlogEdit',
  setup(__props) {

const router = useRouter();
const route = useRoute();

// State
const formRef = ref<any>(null);
const loading = ref(false);
const loadingBlog = ref(false);
const blog = ref(null);
const categories = ref([]);
const error = ref("");

// Methods
const fetchBlog = async () => {
  try {
    loadingBlog.value = true;
    error.value = "";
    const blogId = route.params.id as string;

    if (!blogId) {
      error.value = "Blog ID is required";
      return;
    }

    const response = await apiService.getBlogById(blogId);
    blog.value = response;
  } catch (err: any) {
    console.error("Error fetching blog:", err);
    error.value = err.response?.data?.message || "Failed to load blog";
  } finally {
    loadingBlog.value = false;
  }
};

const fetchCategories = async () => {
  try {
    const response = await apiService.getBlogCategories({ is_active: true });
    categories.value = response.data || [];
  } catch (error) {
    console.error("Error fetching categories:", error);
  }
};

const handleSave = async (blogData: any) => {
  try {
    loading.value = true;
    const blogId = route.params.id as string;

    await apiService.updateBlog(blogId, blogData);

    // Show success message or redirect
    router.push("/blogs");
  } catch (err: any) {
    console.error("Error updating blog:", err);
    alert("Failed to update blog. Please try again.");
  } finally {
    loading.value = false;
  }
};

const saveBlog = () => {
  // Trigger save from the form component
  if (formRef.value) {
    formRef.value.handleSubmit();
  }
};

const goBack = () => {
  router.push("/blogs");
};

// Lifecycle
onMounted(() => {
  fetchCategories();
  fetchBlog();
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", null, [
            _cache[3] || (_cache[3] = _createElementVNode("h4", { class: "mb-0" }, [
              _createElementVNode("i", { class: "fas fa-edit me-2" }),
              _createTextVNode(" Edit Blog ")
            ], -1)),
            _createElementVNode("nav", _hoisted_5, [
              _createElementVNode("ol", _hoisted_6, [
                _createElementVNode("li", _hoisted_7, [
                  _createVNode(_component_router_link, { to: "/pms/admin/dashboard" }, {
                    default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                      _createTextVNode("Dashboard", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_8, [
                  _createVNode(_component_router_link, { to: "/blogs" }, {
                    default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                      _createTextVNode("Blogs", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _cache[2] || (_cache[2] = _createElementVNode("li", { class: "breadcrumb-item active" }, "Edit", -1))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("button", {
              class: "btn btn-outline-secondary",
              onClick: goBack
            }, [...(_cache[4] || (_cache[4] = [
              _createElementVNode("i", { class: "fas fa-arrow-left me-1" }, null, -1),
              _createTextVNode(" Back to List ", -1)
            ]))]),
            _createElementVNode("button", {
              class: "btn btn-success",
              onClick: saveBlog,
              disabled: loading.value
            }, [
              (loading.value)
                ? (_openBlock(), _createElementBlock("span", _hoisted_11))
                : (_openBlock(), _createElementBlock("i", _hoisted_12)),
              _cache[5] || (_cache[5] = _createTextVNode(" Save Changes ", -1))
            ], 8, _hoisted_10)
          ])
        ]),
        (loadingBlog.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [...(_cache[6] || (_cache[6] = [
              _createElementVNode("div", {
                class: "spinner-border text-primary",
                role: "status"
              }, [
                _createElementVNode("span", { class: "visually-hidden" }, "Loading...")
              ], -1),
              _createElementVNode("div", { class: "mt-2" }, "Loading blog...", -1)
            ]))]))
          : (error.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _cache[7] || (_cache[7] = _createElementVNode("i", { class: "fas fa-exclamation-triangle me-2" }, null, -1)),
                _createTextVNode(" " + _toDisplayString(error.value), 1)
              ]))
            : (blog.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _createVNode(BlogForm, {
                      ref_key: "formRef",
                      ref: formRef,
                      blog: blog.value,
                      categories: categories.value,
                      onSave: handleSave,
                      onCancel: goBack
                    }, null, 8, ["blog", "categories"])
                  ])
                ]))
              : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})